import React, { useState, use, useEffect } from "react";
import ReactDOM from "react-dom";
import "./HealthStatusManager.css";
import Modal from "../Modal/Modal";
import { set } from "lodash";
function HealthStatusManager() {
  const [healthStatuses, setHealthStatuses] = useState([]);

  const [showCreateHealthStatusModal, setShowCreateHealthStatusModal] =
    useState(false);

  const [healthStatusToBeDeleted, setHealthStatusToBeDeleted] = useState(null);

  const [newHealthStatusName, setNewHealthStatusName] = useState("");

  useEffect(() => {
    setHealthStatuses(
      window.DataStorage.getHealthStatuses().filter(
        (status) => status.userId === window.myid
      )
    );
  }, []);

  const renderDeleteModalBody = () => {
    return <span>{window.lang.wantDelete}</span>;
  };

  const createHealthStatus = () => {
    if (newHealthStatusName == "") {
      alert("Please select a valid name");
      return;
    }

    window.Spinner.show();

    window.DataGate.addHealthStatus(newHealthStatusName, (code, data) => {
      try {
        data = JSON.parse(data);

        window.DataStorage.setHealthStatuses(data);
        setHealthStatuses(
          window.DataStorage.getHealthStatuses().filter(
            (status) => status.userId === window.myid
          )
        );
      } catch (ex) {
        console.error("Cannot parse server response ", ex);
      } finally {
        window.Spinner.hide();
      }
    });

    setShowCreateHealthStatusModal(false);
  };

  const renderCreateHealthStatusDefaulModalBody = (ev_dispatcher, ev_value) => {
    return (
      <>
        <input
          type="text"
          value={ev_value}
          onChange={(e) => ev_dispatcher(e.currentTarget.value)}
          placeholder={window.lang.name}
          className="field-manager--modal-text-input"
        />
      </>
    );
  };

  const deleteHealthStatus = () => {
    window.Spinner.show();

    window.DataGate.deleteHealthStatus(
      healthStatusToBeDeleted,
      (code, data) => {
        try {
          const newStatuses = window.DataStorage.getHealthStatuses().filter(
            (status) =>
              status.userId === window.myid &&
              status.id !== healthStatusToBeDeleted
          );
          window.DataStorage.setHealthStatuses(newStatuses);
          setHealthStatuses(
            window.DataStorage.getHealthStatuses().filter(
              (status) => status.userId === window.myid
            )
          );
        } catch (ex) {
          console.error("Cannot parse server response ", ex);
        } finally {
          setHealthStatusToBeDeleted(null);
          window.Spinner.hide();
        }
      }
    );

    setShowCreateHealthStatusModal(false);
  };
  return (
    <>
      <div className="field-manager--scroll-area">
        <div className="field-manager--holder">
          <table className="VaccinationTable" style={{ minWidth: 300 }}>
            <thead>
              <tr>
                <th>{window.lang.name}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {healthStatuses.map((status, index) => (
                <tr key={status.id}>
                  <td>{status.name}</td>
                  <td>
                    {/* <img
                    className="actionIcon"
                    src="img/edit_icon.png"
                    // onClick={() => this.onEditVaccinationButtonClick(i)}
                  /> */}
                    <img
                      className="actionIcon"
                      src="img/trashcan.png"
                      onClick={() => setHealthStatusToBeDeleted(status.id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button
            className="ui-btn ui-shadow ui-corner-all"
            style={{ maxWidth: 150 }}
            onClick={() => setShowCreateHealthStatusModal(true)}
          >
            {window.lang.add}
          </button>
        </div>
      </div>
      {showCreateHealthStatusModal && (
        <Modal
          title="Create a health status"
          body={renderCreateHealthStatusDefaulModalBody(
            setNewHealthStatusName,
            newHealthStatusName
          )}
          button1_text={window.lang.add}
          button2_text={window.lang.cancel2}
          button2_callback={() => setShowCreateHealthStatusModal(false)}
          button1_callback={createHealthStatus}
        />
      )}
      {healthStatusToBeDeleted && (
        <Modal
          title={"Delete health status"}
          body={renderDeleteModalBody()}
          button1_text={window.lang.deleteL}
          button2_text={window.lang.cancel2}
          button2_callback={() => {
            setHealthStatusToBeDeleted(null);
          }}
          button1_callback={deleteHealthStatus}
        />
      )}
    </>
  );
}

export default class HealthStatusManagerHolder {
  createHealthStatusManager() {
    ReactDOM.render(
      <HealthStatusManager />,
      document.getElementById("healthStatusPageReact")
    );
  }
}
